import type { AgentCategory, AgentCategoryId } from '../../types/platform'
import { INTAKE_TO_COMMUNICATION } from './intakeToCommunication'
import { DILIGENCE_TO_MONITORING } from './diligenceToMonitoring'

/** All eight agent categories, in process order. */
export const AGENT_CATEGORIES: AgentCategory[] = [...INTAKE_TO_COMMUNICATION, ...DILIGENCE_TO_MONITORING]

export const AGENT_COUNT = AGENT_CATEGORIES.reduce((total, category) => total + category.agents.length, 0)

export function getAgentCategory(id: AgentCategoryId) {
  return AGENT_CATEGORIES.find((category) => category.id === id)!
}

export function agentSlug(name: string) {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}
